import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { Observable, from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AwsService {
  private s3: S3Client;

  constructor() {
    this.s3 = new S3Client({
      region: "environment.aws.region",
      credentials: {
        accessKeyId: "environment.aws.accessKeyId",
        secretAccessKey: "environment.aws.secretAccessKey",
      },
    });
  }

  getImageUrl(bucket: string, key: string): Observable<string> {
    if (!key) {
      return of('assets/images/no-profile-image.png');
    }
    const command = new GetObjectCommand({
      Bucket: bucket,
      Key: key,
      ResponseContentType: 'image/jpeg',
      ResponseCacheControl: 'no-cache'
    });

    return from(getSignedUrl(this.s3, command, { expiresIn: 3600 })).pipe(
      catchError(error => {
        console.error('AWS Error:', error);
        return of('assets/images/no-profile-image.png');
      })
    );
  }

  // For public images (if your bucket is configured to allow public access)
  getPublicImageUrl(bucket: string, key: string): Observable<string> {
    if (!bucket || !key) {
      return of('assets/images/no-profile-image.png');
    }
    try {
      const region = "environment.aws.region";
      // Properly encode the key for URL safety
      const encodedKey = encodeURIComponent(key).replace(/%2F/g, '/');
      const url = `https://${bucket}.s3.${region}.amazonaws.com/${encodedKey}`;
      return of(url);
    } catch (error) {
      console.error('Error generating public URL:', error);
      return of('assets/images/no-profile-image.png');
    }
  }
}
